<app-modal [title]="'Read full review'" [disableSave]="true" [hideSave]="true">
  <div style="padding: 16px 0;">
    <app-review-card [review]="data.review" [expandable]="false"></app-review-card>
  </div>
</app-modal>
